import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import {Container,Grid,Typography,Autocomplete,TextField,RadioGroup,FormControlLabel,Radio,FormControl,FormLabel,FormGroup,Checkbox,
  Button,Paper,Table,TableHead,TableRow,TableCell,TableBody,TablePagination,IconButton,
} from "@mui/material";
import Swal from "sweetalert2";
import { BASE_URL } from "../../App";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import { green, red, blue } from "@mui/material/colors";

const INITIAL_SEGMENTS = {
  AR: false,
  BCS: false,
  VALVES: false,
  SOLAR: false,
  MINI: false,
  FIELDSERVICE: false,
  INSTALL: false,
  // RO: false,
};

const AscSegmentConfig = () => {
  const [branchOptions, setBranchOptions] = useState([]);
  const [ascOptions, setAscOptions] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedAsc, setSelectedAsc] = useState(null);
  const [category, setCategory] = useState("");
  const [segments, setSegments] = useState(INITIAL_SEGMENTS);
  const [configList, setConfigList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const login_id = localStorage.getItem("LOGIN_ID");

  const showLoading = () => {
    Swal.fire({
      title: "Loading",
      text: "Please wait...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
  };

  const closeLoading = () => Swal.close();

  useEffect(() => {
    const fetchBranches = async () => {
      showLoading();
      try {
        const response = await axios.post(`${BASE_URL}/getBranch`, {
          //  loginid: "ADMIN",
          // LOGIN_ID: loginid,
          loginId: login_id,
        });
        setBranchOptions(response.data.branches || []);
      } catch (error) {
        Swal.fire("Error", "Failed to fetch branches.", "error");
      } finally {
        closeLoading();
      }
    };
    fetchBranches();
  }, []);

  useEffect(() => {
    // const fetchASCs = async () => {
    //   if (!selectedBranch) return;
    //   showLoading();
    //   try {
    //     const response = await axios.post(`${BASE_URL}/getAscByBranch`, {
    //       BRANCH_CODE: selectedBranch.BRANCH_CODE,
    //     });
    //     setAscOptions(response.data.ascs || []);
    //   } catch (error) {
    //     Swal.fire("Error", "Failed to fetch ASC list.", "error");
    //   } finally {
    //     closeLoading();
    //   }
    // };

    const fetchASCs = async () => {
      if (!selectedBranch) return;
      showLoading();
      try {
        const response = await axios.post(`${BASE_URL}/getAscByBranch`, {
          BRANCH_CODE: selectedBranch.BRANCH_CODE,
        });
    
        const mappedASCs = (response.data.ascs || []).map(asc => ({
          ...asc,
          code: asc.ASC_CODE, 
        }));
    
        setAscOptions(mappedASCs);
      } catch (error) {
        Swal.fire("Error", "Failed to fetch ASC list.", "error");
      } finally {
        closeLoading();
      }
    };
    
    fetchASCs();
  }, [selectedBranch]);

  const fetchConfigs = async () => {
    if (!selectedBranch || !category) return;
    showLoading();
    try {
      const response = await axios.post(`${BASE_URL}/getAscSegmentConfig`, {
        branch_code: selectedBranch.BRANCH_CODE,
        category,
      });
  
      if (response.data?.data) {
        const normalized = (response.data.data || []).map((row) => ({
          branch: row.branch_code,
          ascCode: row.ASC_CODE,
          category: row.category,
          dealer_code: row.dealer_code,
          SHOP_NAME: row.SHOP_NAME,
          segments: {
            AR: row.A_R,
            BCS: row.BCS,
            VALVES: row.VOLVS,
            SOLAR: row.SOLAR,
            MINI: row.MINI,
            FIELDSERVICE: row.FIELD_SERVICE,
            INSTALL: row.INSTALLER,
            // RO: row.RO,
          },
        }));
        setConfigList(normalized);
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Failed to fetch segment configurations.", "error");
    } finally {
      closeLoading();
    }
  };
  

  // useEffect(() => {
  //   if (selectedBranch && category && selectedAsc) {
  //     fetchConfigs();
  //   }
  // }, [selectedAsc]);

  // const handleSegmentChange = useCallback((e) => {
  //   setSegments((prev) => ({
  //     ...prev,
  //     [e.target.name]: e.target.checked,
  //   }));
  // }, []);

  useEffect(() => {
    if (selectedBranch && category && selectedAsc) {
      fetchConfigs();
    }
  }, [selectedAsc]);
  
  const findConfigForSelectedAsc = (ascCode, branchCode, category) => {
    return configList.find(
      (config) =>
        config.ascCode === ascCode &&
        config.branch === branchCode &&
        config.category === category
    );
  };
  
  // Already existing handler below
  const handleSegmentChange = useCallback((e) => {
    setSegments((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }));
  }, []);
  

  const handleSubmit = async () => {
  if (!selectedBranch || !selectedAsc || !category) {
    Swal.fire("Validation Error", "Please select Branch, ASC, and Category.", "warning");
    return;
  }

  // Normalize the segments to ensure all fields are included in the payload
  const normalizeSegments = (segments) => {
    return {
      A_R: segments.AR ? "1" : "0", 
      BCS: segments.BCS ? "1" : "0",
      VOLVS: segments.VALVES ? "1" : "0",
      SOLAR: segments.SOLAR ? "1" : "0",
      MINI: segments.MINI ? "1" : "0",
      FIELD_SERVICE: segments.FIELDSERVICE ? "1" : "0",
      INSTALL: segments.INSTALLER ? "1" : "0", 
      // RO: segments.RO ? "1" : "0",
    };
  };

  const payload = {
    branch: selectedBranch.BRANCH_CODE,
    ascCode: selectedAsc.code,
    category,
    segments: normalizeSegments(segments),  // Make sure 'segments' object is included
  };

  showLoading();
  try {
    await axios.post(`${BASE_URL}/saveSegmentConfig`, payload);
    fetchConfigs();
    Swal.fire("Success", "Configuration saved successfully!", "success");
    setSegments(INITIAL_SEGMENTS);
    setCategory("");
    setSelectedBranch(null);
    setSelectedAsc(null);
  } catch (error) {
    Swal.fire("Error", "Failed to save configuration.", "error");
  } finally {
    closeLoading();
  }
};


  const handleEdit = (config) => {
    setSelectedBranch({ BRANCH_CODE: config.branch });
    setSelectedAsc({ code: config.ascCode });
    setCategory(config.category);
    setSegments(
      Object.fromEntries(
        Object.entries(config.segments).map(([k, v]) => [k, v === "1"])
      )
    );
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Paper sx={{ p: 4 }}>
        {/* <Typography variant="h5" gutterBottom>
          ASC Segment Configuration
        </Typography> */}

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Category</FormLabel>
              <RadioGroup
                row
                value={category}
                onChange={(e) => {
                  setCategory(e.target.value);
                  setSegments(INITIAL_SEGMENTS);
                  if (selectedAsc) fetchConfigs();
                }}
              >
                {["DASC", "CASC", "DOSC"].map((cat) => (
                  <FormControlLabel
                    key={cat}
                    value={cat}
                    control={<Radio />}
                    label={cat}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* <Grid item xs={12} sm={6}>
            <Autocomplete
              options={branchOptions}
              getOptionLabel={(option) => option.BRANCH_NAME ?? ""}
              value={selectedBranch}
              onChange={(e, value) => {
                setSelectedBranch(value);
                setSelectedAsc(null);
                setSegments(INITIAL_SEGMENTS);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select Branch" variant="outlined" />
              )}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
   <Autocomplete
  options={branchOptions}
  getOptionLabel={(option) =>
    option.BRANCH_CODE && option.BRANCH_NAME
      ? `${option.BRANCH_CODE} - ${option.BRANCH_NAME}`
      : ""
  }
  isOptionEqualToValue={(option, value) =>
    option.BRANCH_CODE === value.BRANCH_CODE
  }
  value={selectedBranch}
  onChange={(e, value) => {
    setSelectedBranch(value);
    setSelectedAsc(null);
    setSegments(INITIAL_SEGMENTS);
  }}
  renderInput={(params) => (
    <TextField {...params} label="Select Branch" variant="outlined" />
  )}
/>
</Grid>



          <Grid item xs={12} sm={6}>
            {/* <Autocomplete
              options={ascOptions}
              getOptionLabel={(option) => option.ASC_NAME ?? ""}
              value={selectedAsc}
              onChange={(e, value) => {
                setSelectedAsc(value);
                setSegments(INITIAL_SEGMENTS);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select ASC" variant="outlined" />
              )}
              disabled={!selectedBranch}
            /> */}
<Autocomplete
  options={ascOptions}
  getOptionLabel={(option) => option.ASC_NAME ?? ""}
  value={selectedAsc}
  onChange={(e, value) => {
    setSelectedAsc(value);
    if (value && selectedBranch && category) {
      const match = findConfigForSelectedAsc(value.code, selectedBranch.BRANCH_CODE, category);
      if (match) {
        setSegments(
          Object.fromEntries(
            Object.entries(match.segments).map(([k, v]) => [k, v === "1"])
          )
        );
      } else {
        setSegments(INITIAL_SEGMENTS);
      }
    } else {
      setSegments(INITIAL_SEGMENTS);
    }
  }}
  renderInput={(params) => (
    <TextField {...params} label="Select ASC" variant="outlined" />
  )}
  disabled={!selectedBranch}
/>


          </Grid>

          {selectedAsc && category && (
            <Grid item xs={12}>
              <FormControl component="fieldset" variant="standard">
                <FormLabel component="legend">Segments</FormLabel>
                <FormGroup row>
                  {Object.keys(segments).map((seg) => (
                    <FormControlLabel
                      key={seg}
                      control={
                        <Checkbox
                          checked={segments[seg]}
                          onChange={handleSegmentChange}
                          name={seg}
                        />
                      }
                      label={seg}
                    />
                  ))}
                </FormGroup>
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={fetchConfigs}
              disabled={!category || !selectedBranch}
            >
              View Configuration
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={!category || !selectedBranch || !selectedAsc}
            >
              Save Configuration
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ mt: 4, p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Configured Entries
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
              <TableCell sx={{ fontWeight: "bold" }}>Branch</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>ASC Code</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Dealer Code</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Shop Name</TableCell>
              {Object.keys(INITIAL_SEGMENTS).map((seg) => (
                <TableCell key={seg} sx={{ fontWeight: "bold" }}>{seg}</TableCell>
              ))}
              <TableCell sx={{ fontWeight: "bold" }}>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {configList
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((item, idx) => (
                <TableRow key={idx}>
                  <TableCell>{item.branch}</TableCell>
                  <TableCell>{item.ascCode}</TableCell>
                  <TableCell>{item.category}</TableCell>
                  <TableCell>{item.dealer_code || "N/A"}</TableCell>
                  <TableCell>{item.SHOP_NAME || "N/A"}</TableCell>
                  {Object.keys(INITIAL_SEGMENTS).map((seg) => (
                    <TableCell key={seg}>
                      {item.segments[seg] === "1" ? (
                        <CheckCircleIcon sx={{ color: green[500] }} />
                      ) : item.segments[seg] === "0" ? (
                        <CancelIcon sx={{ color: red[500] }} />
                      ) : (
                        "N/A"
                      )}
                    </TableCell>
                  ))}
                  <TableCell>
                    <IconButton onClick={() => handleEdit(item)}>
                      <EditIcon sx={{ color: blue[700] }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={configList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />
      </Paper>
    </Container>
  );
};

export default AscSegmentConfig;
